import type { Module } from '../types';

export const GMP_MODULES: Module[] = [
  {
    id: 1,
    title: "GMP & Regulations",
    description: "Foundation of pharmaceutical regulations and GMP principles",
    icon: "📋",
    color: "#4F46E5",
    position: { x: 10, y: 80 },
    completed: false,
    unlocked: true,
    levels: [
      {
        id: 1,
        name: "Introduction to GMP",
        description: "Understand the basics of Good Manufacturing Practices.",
        difficulty: "Beginner",
        stars: 2,
        taxonomy: "Recall",
        time: 15,
      },
      {
        id: 2,
        name: "Regulatory Bodies",
        description: "Learn about the key regulatory agencies in pharmaceuticals.",
        difficulty: "Intermediate",
        stars: 3,
        taxonomy: "Classify",
        time: 20,
      },
      {
        id: 3,
        name: "GMP Guidelines",
        description: "Explore detailed guidelines and requirements of GMP.",
        difficulty: "Advanced",
        stars: 3,
        taxonomy: "Apply",
        time: 25,
      },
      {
        id: 4,
        name: "GMP Analysis",
        description: "Analyze complex GMP scenarios and case studies.",
        difficulty: "Expert",
        stars: 4,
        taxonomy: "Analyze",
        time: 30,
      },
    ],
  },
  {
    id: 2,
    title: "Pharma Functions",
    description: "Core pharmaceutical manufacturing and quality functions",
    icon: "🏭",
    color: "#059669",
    position: { x: 25, y: 60 },
    completed: false,
    unlocked: true,
    levels: [
      {
        id: 1,
        name: "Manufacturing Processes",
        description: "Overview of pharmaceutical manufacturing techniques.",
        difficulty: "Beginner",
        stars: 2,
        taxonomy: "Recall",
        time: 15,
      },
      {
        id: 2,
        name: "Quality Control",
        description: "Methods for ensuring product quality and consistency.",
        difficulty: "Intermediate",
        stars: 3,
        taxonomy: "Classify",
        time: 20,
      },
      {
        id: 3,
        name: "Packaging and Labeling",
        description: "Requirements for packaging and labeling of drug products.",
        difficulty: "Advanced",
        stars: 3,
        taxonomy: "Apply",
        time: 25,
      },
      // {
      //   id: 4,
      //   name: "Pharma Functions Analysis",
      //   description: "Analyze complex Pharma Functions scenarios and case studies.",
      //   difficulty: "Expert",
      //   stars: 4,
      //   taxonomy: "Analyze",
      //   time: 30,
      // },
    ],
  },
  {
    id: 3,
    title: "GDocP & Data Integrity",
    description: "Good Documentation Practices and maintaining data integrity",
    icon: "📊",
    color: "#DC2626",
    position: { x: 45, y: 70 },
    completed: false,
    unlocked: true,
    levels: [
      {
        id: 1,
        name: "Documentation Basics",
        description: "Introduction to good documentation practices.",
        difficulty: "Beginner",
        stars: 2,
        taxonomy: "Recall",
        time: 15,
      },
      {
        id: 2,
        name: "Data Integrity Principles",
        description: "Understanding ALCOA principles in data management.",
        difficulty: "Intermediate",
        stars: 3,
        taxonomy: "Classify",
        time: 20,
      },
      {
        id: 3,
        name: "Electronic Records",
        description: "Managing electronic records and signatures.",
        difficulty: "Advanced",
        stars: 3,
        taxonomy: "Apply",
        time: 25,
      },
      // {
      //   id: 4,
      //   name: "GDocP Analysis",
      //   description: "Analyze complex GDocP scenarios and data integrity issues.",
      //   difficulty: "Expert",
      //   stars: 4,
      //   taxonomy: "Analyze",
      //   time: 30,
      // },
    ],
  },
  {
    id: 4,
    title: "Self-Inspection & Audit",
    description: "Internal auditing and self-inspection processes",
    icon: "🔍",
    color: "#7C2D12",
    position: { x: 65, y: 50 },
    completed: false,
    unlocked: false,
    levels: [
      {
        id: 1,
        name: "Audit Preparation",
        description: "Preparing for internal and external audits.",
        difficulty: "Beginner",
        stars: 2,
        taxonomy: "Recall",
        time: 15,
      },
      {
        id: 2,
        name: "Conducting Audits",
        description: "Techniques for conducting effective audits.",
        difficulty: "Intermediate",
        stars: 3,
        taxonomy: "Classify",
        time: 20,
      },
      {
        id: 3,
        name: "Audit Reporting",
        description: "Writing and managing audit reports.",
        difficulty: "Advanced",
        stars: 3,
        taxonomy: "Apply",
        time: 25,
      },
      {
        id: 4,
        name: "Audit Analysis",
        description: "Analyze audit findings and develop improvement plans.",
        difficulty: "Expert",
        stars: 4,
        taxonomy: "Analyze",
        time: 30,
      },
    ],
  },
  {
    id: 5,
    code: "HL1",
    title: "Qualification & Validation",
    description: "Equipment qualification and process validation activities (Simulation Only: Violation & Root Cause)",
    icon: "✅",
    color: "#B45309",
    position: { x: 80, y: 70 },
    completed: false,
    unlocked: false,
    levels: [], // No levels, simulation only
  },
  {
    id: 6,
    code: "HL2",
    title: "Change Control",
    description: "Managing changes to systems, processes, and procedures (Simulation Only: Solution)",
    icon: "🔄",
    color: "#7C3AED",
    position: { x: 85, y: 40 },
    completed: false,
    unlocked: false,
    levels: [], // No levels, simulation only
  },
];
